import React from 'react';

import './page-header.scss';

const Component = ({ children }) => (
    <h1 className="page-header">{ children }</h1>
);

export default Component;
